import { render, staticRenderFns } from "./Oct27th.vue?vue&type=template&id=c26f4888&scoped=true&"
import script from "./Oct27th.vue?vue&type=script&lang=js&"
export * from "./Oct27th.vue?vue&type=script&lang=js&"
import style0 from "./Oct27th.vue?vue&type=style&index=0&id=c26f4888&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c26f4888",
  null
  
)

export default component.exports